import { render, staticRenderFns } from "./exportBlockDialog.vue?vue&type=template&id=db8e27b4"
import script from "./exportBlockDialog.vue?vue&type=script&lang=js"
export * from "./exportBlockDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports